module.exports = __webpack_public_path__ + "assets/divider.6f538868.svg";